export enum Inventory {
  OneSize = 'one-size',
}
